export const PlayerIdData  = {
    'MS Dhoni': 1,
    'Ravindra Jadeja':2,
    'Moeen Ali':3,
    'Deepak Chahar':4,
    'Mitchell Santner':5,

    'Rohit Sharma':6,
    'Suryakumar Yadav':7,
    'Ishan Kishan':8,
    'Jasprit Bumrah':9,
    'Kieron Pollard':10,
 
    'Hardik Pandya':11,
    'David Miller':12,
    'Shubman Gill':13,
    'Rashid Khan':14,
    'Mohammed Shami':15,
 
    'Sanju Samson':16,
    'Jos Buttler':17,
    'Devdutt Padikkal':18,
    'Trent Boult':19,
    'Yuzi Chahal':20 
 }